import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { VimeoPlayerModule } from '@epicuro-next/ataraxia/vimeo-player';
import { DataVimeoModule } from '@epicuro-next/data/vimeo';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';

import { VimeoChatComponent } from './components/vimeo-chat/vimeo-chat.component';
import { NAMESPACE_VIMEO } from './constants';
import { VimeoThumbnailsComponent } from './containers/vimeo-thumbnails/vimeo-thumbnails.component';
import { VimeoComponent } from './containers/vimeo/vimeo.component';
import { VimeoFeatureService } from './services/vimeo.service';

@NgModule({
  imports: [
    CommonModule,
    DataVimeoModule,
    ImageModule,
    IconsModule,
    ConfigurationModule.forFeature(NAMESPACE_VIMEO),
    VimeoPlayerModule,
  ],
  providers: [VimeoFeatureService],
  declarations: [VimeoComponent, VimeoChatComponent, VimeoThumbnailsComponent],
  exports: [VimeoComponent, VimeoThumbnailsComponent],
})
export class FeaturesVimeoModule {}
